import React from "react";
import {
  BLOCK_LIST_WIDTH,
  BLOCK_SETTINGS_WIDTH
} from "utils/constants/builder";
import { getShimmerClass } from "utils/constants/ui";
import classnames from "classnames";
import DetailLoader from "components/DetailLoader";
import PreviewLoader from "./PreviewLoader";

const BuilderLoader = ({ withPanel = false, withShimmer = true }) => {
  const shimmerClass = getShimmerClass(withShimmer);
  const blockListContent = new Array(6).fill("").map((_, stubIx) => (
    <div
      key={stubIx}
      className={classnames(`h3 w-100 ${shimmerClass}`, {
        mt3: stubIx
      })}
    ></div>
  ));

  return (
    <div className="flex flex-row h-100 w-100">
      <div className="w-100 db dn-ns h-100 bg-white pa3">
        {blockListContent}
      </div>
      <div
        style={{ width: BLOCK_LIST_WIDTH }}
        className={"dn flex-ns flex-column fl h-100 pa3 bg-white bh--inset"}
      >
        {blockListContent}
      </div>
      <div
        className="dn flex-ns fl h-100"
        style={{ width: `calc(100% - ${BLOCK_LIST_WIDTH}px)` }}
      >
        {withPanel && (
          <div
            className="bg-white w-100 h-100 bh--inset overflow-y-scroll-ns"
            style={{ width: BLOCK_SETTINGS_WIDTH }}
          >
            <DetailLoader />
          </div>
        )}
        <div className="w-100 bg-content--secondary overflow-y-scroll-ns overflow-x-hidden ph3">
          <PreviewLoader withShimmer={withShimmer} />
        </div>
      </div>
    </div>
  );
};

export default BuilderLoader;
